import React from "react";
import PropTypes from "prop-types";
import { H2 } from "theme/components/atoms/Typography/Heading";
import { ProductPrice } from "theme/components/atoms/Typography/Price";
import Image from "theme/components/atoms/Image";

const ProductAddedPopInBody = (props) => (
  <div className="product-added__content">
    <div className="product-added__image">
      <Image src={props.imageUrl} alt={props.name} format="small" />
    </div>
    <div className="product-added__details">
      <div className="product-added__title">
        <H2>{props.name}</H2>
      </div>
      <div className="product-added__price">
        <ProductPrice prices={props.prices} />
      </div>
    </div>
  </div>
);

ProductAddedPopInBody.propTypes = {
  imageUrl: PropTypes.string,
  sku: PropTypes.string,
  name: PropTypes.string,
};

export default ProductAddedPopInBody;
